<template>
  <el-card v-loading="loading">
    <template slot="header">
      修改管理员信息
    </template>
    <el-form :model="AdminManger"
             :rules="rules"
             ref="ruleForm"
             label-position="right"
             label-width="80px">
      <el-form-item label="登录名" prop="name">
        <el-input v-model="AdminManger.name"></el-input>
      </el-form-item>
      <el-form-item label="邮箱地址" prop="email">
        <el-input v-model="AdminManger.email"></el-input>
      </el-form-item>
      <el-form-item label="原始密码" prop="old_password">
        <el-input v-model="AdminManger.old_password"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="new_password">
        <el-input v-model="AdminManger.new_password"></el-input>
      </el-form-item>
      <el-form-item label="管理员组" prop="roles">
        <el-checkbox-group v-model="AdminManger.roles" style="line-height: 40px;">
          <el-checkbox v-for="role in roles" :label="role.id" :key="role.id">{{role.display_name}}</el-checkbox>
        </el-checkbox-group>
        <p v-if="roles.length == 0" style="padding:0;margin:0;line-height: 40px;color: #606266">
          暂无
        </p>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="update('ruleForm')">保存</el-button>
        <el-button type="success" @click="back">返回</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
  import {mapState} from 'vuex'
  import '@/static/test'

  export default {
    name: "AdminEdit",
    props: {
      id: {
        required: true
      }
    },
    components: {},
    data() {
      return {
        admin: {}
      }
    },
    computed: {
      ...mapState({
        AdminManger: state => state.adminManger.Admin,
        roles: state => state.roles.list,
        rules: state => state.adminManger.rules,
        loading: state => state.adminManger.loading
      })
    },
    methods: {
      back() {
        this.$router.back();
      },
      update(form) {
        let vthis = this;

        this.$refs[form].validate((validate) => {
          if (!validate) {
            return;
          }
          this.$store.dispatch('adminManger/update').then(res => {
            vthis.$confirm('是否关闭页面?')
              .then(_ => {
                vthis.$router.back();
              });
          })
            .catch(res => {
              console.log(res);
            });
        });

      }
    },
    created() {
      this.$store.dispatch('adminManger/show', {id: this.id});
      this.$store.dispatch('roles/getList');
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/admin/AdminEdit.vue